import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PageLinksData } from './page-links';
import { GroupByPageTypePipe } from '../pipes/group-by-page-type.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { ArrowLinkComponent } from '@shared/arrow-link/arrow-link.component';
import { ImageComponent } from '@shared/image/image/image.component';
import { NgFor, NgIf, NgTemplateOutlet, KeyValuePipe } from '@angular/common';
import { trackByPageViewModel } from '@shared/track-by/track-by-id';

@Component({
    selector: 'app-page-links',
    templateUrl: './page-links.component.html',
    styleUrls: ['./page-links.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgFor,
        ImageComponent,
        ArrowLinkComponent,
        NgIf,
        NgTemplateOutlet,
        KeyValuePipe,
        TranslateModule,
        GroupByPageTypePipe
    ]
})
export class PageLinksComponent {
    public readonly trackByPageViewModel = trackByPageViewModel;

    @Input()
    data: PageLinksData;
}
